export const componentIds = {
  StepGroup: 'StepGroup',
  StepItem: 'StepItem',
};
